import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import { useForm } from "antd/es/form/Form";
import TextArea from "antd/es/input/TextArea";
import {
  ArrowLeftOutlined,
  InboxOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
import { useState } from "react";
import { BASE_URL } from "../../api/Constants";
import Meta from "antd/es/card/Meta";

const { Title, Text } = Typography;

const FormSerie = (props) => {
  const {
    onFinish,
    collections,
    errorMsg,
    title,
    initialValues,
    type,
    goBack,
    accessEps,
    accessCollection,
    imgDetails,
  } = props;

  const isUpdate = type === "update";

  const [form] = useForm();

  const [fileList, setFileList] = useState([]);
  const [errMsgCover, setErrMsgCover] = useState("");

  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);

  const checkFile = (file) => {
    setErrMsgCover("");
    console.log(file);
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      setErrMsgCover("You can only upload JPG/PNG file!");
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 1;
    if (!isLt2M) {
      setErrMsgCover("Image must smaller than 1MB!");
      return false;
    }

    const regex =
      "(bigcard|card|carousel|default|header|logo|verboseCard|verboseCarousel|highlight|collection){1}(@\\d\\dx)?.(png|jpg|jpeg){1}";
    if (!file.name.match(regex)) {
      setErrMsgCover(
        "Nom du fichier pas standard (accept : bigcard|card|carousel|default|header|logo|verboseCard|verboseCarousel|highlight|collection"
      );
      return false;
    }

    return true;
  };

  return (
    <>
      <Row style={{ marginBottom: 50 }} align="middle">
        {goBack ? (
          <Col span={1}>
            <Button
              shape="circle"
              icon={<ArrowLeftOutlined />}
              onClick={goBack}
            />
          </Col>
        ) : null}

        <Col span={14}>
          <Title style={{ margin: 0, marginLeft: 10 }} level={3}>
            {title}
          </Title>
        </Col>
        {isUpdate ? (
          <>
            <Col span={3}>
              <Button type={"default"} onClick={accessCollection}>
                Accéder à la collection
              </Button>
            </Col>
            <Col offset={2} span={3}>
              <Button type={"primary"} onClick={accessEps}>
                Accéder aux épisodes
              </Button>
            </Col>
          </>
        ) : null}
      </Row>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={initialValues}
      >
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              label="Collections"
              name="collectionName"
              rules={[{ required: true, message: "Choisir une collection" }]}
            >
              <Select
                disabled={isUpdate}
                showSearch
                placeholder="Rechercher une collection"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? "")
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? "").toLowerCase())
                }
                options={
                  collections
                    ? collections.map((c) => {
                        return { label: c.name, value: c.name };
                      })
                    : null
                }
              />
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item
              label="Nom de la série"
              name="serieName"
              rules={[{ required: true, message: "Choisir un nom de série" }]}
            >
              <Input placeholder="Lulu fait du surf 🏄‍♂️" />
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item
              label="UID Série"
              name="uidSerie"
              rules={[{ required: true, message: "Insérer un UID valide" }]}
            >
              <Input disabled={isUpdate} placeholder="UID_SERIE" />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Statut de la série" name="serieState">
              <Select
                options={[
                  { value: "free", label: "Gratuit" },
                  { value: "subscribed", label: "Abonné" },
                  { value: "admin", label: "Administrateur" },
                  { value: "unavailable", label: "Indisponible" },
                ]}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={9}>
            <Form.Item
              label="Auteur"
              name="author"
              rules={[{ required: true, message: "Auteur nécessaire" }]}
            >
              <Input placeholder="Anne-Marie Desplat Duc" />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="Illustrateur"
              name="illustrator"
              rules={[{ required: true, message: "Illustrateur nécessaire" }]}
            >
              <Input placeholder="Picasso" />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Crédits" name="legalLines">
              <Input placeholder="© Procidis" />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Age" name="age">
              <InputNumber min={7} max={20} defaultValue={10} />
            </Form.Item>
          </Col>
        </Row>
        {!isUpdate ? (
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                label="Résumé"
                name="sumup"
                rules={[
                  {
                    required: true,
                    message: "Résumé de 500 caractères maximum",
                  },
                ]}
              >
                <TextArea
                  placeholder="Il était une fois Lulu à Brest qui allait à la plage faire du surf..."
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  showCount
                  maxLength={500}
                />
              </Form.Item>
            </Col>
          </Row>
        ) : null}
        <Form.Item wrapperCol={{ span: 16 }}>
          <Button type="primary" htmlType="submit">
            Enregistrer
          </Button>
        </Form.Item>
        <Text type="danger">{errorMsg}</Text>
      </Form>
      {isUpdate ? (
        <>
          <Dragger
            style={{ marginBottom: 15 }}
            action={`${BASE_URL}/serie/${initialValues.uidSerie}/cover`}
            withCredentials={true}
            listType="picture"
            multiple
            fileList={fileList}
            onChange={handleChange}
            beforeUpload={checkFile}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p className="ant-upload-hint">
              Support for a single or bulk upload. Strictly prohibited from
              uploading company data or other banned files.
            </p>
          </Dragger>
          <Text type="danger">{errMsgCover}</Text>
          <Space wrap>
            {imgDetails.map((i) => {
              return (
                <Card
                  key={i.name}
                  hoverable
                  style={{ width: 240 }}
                  cover={<img alt="example" src={i.url} />}
                  actions={[
                    <a
                      key="downloadCover"
                      download
                      href={i.url}
                      title="ImageName"
                    >
                      <DownloadOutlined />
                    </a>,
                  ]}
                >
                  <Meta description={i.name} />
                </Card>
              );
            })}
          </Space>
        </>
      ) : null}
    </>
  );
};

export default FormSerie;
